var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32Z",
    fill: "#32A936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1538 20.9231C14.1538 16.1649 17.409 12.3077 21.4245 12.3077C25.44 12.3077 28.6951 16.1649 28.6951 20.9231C28.6951 20.9231 25.44 19.0385 21.4245 19.0384C17.409 19.0384 14.1538 20.9231 14.1538 20.9231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3049 20.9231C35.3049 16.1649 38.56 12.3077 42.5755 12.3077C46.591 12.3077 49.8461 16.1649 49.8461 20.9231C49.8461 20.9231 46.591 19.0385 42.5755 19.0384C38.56 19.0384 35.3049 20.9231 35.3049 20.9231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9231 27.0769C52.9231 37.9528 43.5554 46.7692 32 46.7692C20.4446 46.7692 11.0769 37.9528 11.0769 27.0769C11.0769 27.0769 20.4446 31.3846 32 31.3846C43.5554 31.3846 52.9231 27.0769 52.9231 27.0769Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonGood);
export default __webpack_public_path__ + "static/media/button-good.054b554e1631010061aef8daa9a79368.svg";
export { ForwardRef as ReactComponent };